import React, { useEffect, useState } from "react";
import ImageCarousel from "./ImageCarousel";
import axios from "axios";
import { base_URL } from "../../config/config";
import { useNavigate } from "react-router-dom";

const Spaces = () => {
	const [areaCounts, setAreaCounts] = useState({});
	const navigate = useNavigate();

	// Fetch area counts from the API
	useEffect(() => {
		const fetchAreaCounts = async () => {
			try {
				const response = await axios.get(`${base_URL}/api/getAreaCount`);
				setAreaCounts(response?.data);
			} catch (error) {
				console.error("Error fetching area counts:", error);
			}
		};

		fetchAreaCounts();
	}, []);

	const handleRedirect = (cityName, areaCount) => {
		const slug = cityName
			?.toLowerCase()
			?.replace(/[^a-z0-9]+/g, "-") // replace spaces/specials with hyphens
			?.replace(/(^-|-$)/g, "");
		navigate(`/city/${slug}?areaCount=${JSON.stringify(areaCount)}`);
	};
	return (
		<div className="flex justify-center w-full ">
			<div className="w-[90%] md:flex md:flex-col items-center ">
				<h1 className="text-[#222] sm:text-4xl text-2xl font-semibold text-center custom-m">
					Discover Popular Event Spaces in the UAE
				</h1>
				<div className="md:flex hidden h-full w-full gap-5 mt-10">
					{/* Left Side - Dubai */}
					<div
						className="bg-white border rounded-lg relative flex-col flex items-center cursor-pointer"
						style={{ width: "20%", height: "580px" }} // Fixed height to match previous
						onClick={() => handleRedirect("Dubai", areaCounts.Dubai)}
					>
						<img
							src="https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FDubai-compressed_1_kxquzi.jpg?alt=media&token=6e311247-040c-400f-a8b8-abc9cbf85c2c"
							alt="Dubai"
							fetchPriority="high"
							decoding="async"
							className="rounded-lg h-full w-full object-cover z-20"
						/>
						<div className="flex flex-col items-center justify-end pb-3 bg-shadow-gradient bottom-0 w-full md:h-[7rem] h-[3rem] absolute rounded-b-lg z-30">
							<h1 className="text-lg font-bold">Dubai</h1>
							<p className="text-[16px] text-[#5E5E5E] font-medium">
								{areaCounts.Dubai?.totalCount || 0} venues
							</p>
						</div>
					</div>
					<div className="grid grid-cols-3 grid-rows-2 gap-5 w-[80%]">
						{[
							{
								name: "Abu Dhabi",
								img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FAbu_Dhabi_slr7x6.jpg?alt=media&token=0535cf08-2dd0-4b51-b345-5d1f35f8e241",
							},
							{
								name: "Sharjah",
								img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FSharjah-compressed_ngrlhi.jpg?alt=media&token=3a1d3870-4559-4ed8-b84d-8c7653f7fa0e",
							},
							{
								name: "Umm Al Quwain",
								img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FUmm_Al_Quwain_j3cfex.jpg?alt=media&token=ad889cbc-87b3-4cf6-9974-b50a4b84b213",
							},
							{
								name: "Ras Al Khaimah",
								img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FRas_Al_Khaimah_hthpwd.jpg?alt=media&token=95336664-8510-4f1c-8c62-ada1de3de1cd",
							},
							{
								name: "Fujairah",
								img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FFujairah_cqybav.jpg?alt=media&token=5aa71f77-3349-42c0-9a7a-249b47293031",
							},
							{
								name: "Ajman",
								img: "https://firebasestorage.googleapis.com/v0/b/findmyvenueprod.firebasestorage.app/o/fmv%20cities%2FAjman_cp0adp.jpg?alt=media&token=0025da78-eec7-4579-931e-7195db74e528",
							},
						].map((city, index) => (
							<div
								key={index}
								className="bg-white border rounded-lg flex flex-col w-full items-center cursor-pointer overflow-hidden relative z-10"
								onClick={() => {
									console.log("Redirecting to:", city.name);
									handleRedirect(city.name, areaCounts[city.name]);
								}}
							>
								{/* Image should not take full space so text fits */}
								<img
									src={city.img}
									alt={city.name}
									loading="lazy"
									decoding="async"
									className="w-full h-[220px] object-cover rounded-lg"
								/>
								{/* Name & Venue Count BELOW the image - not inside */}
								<div className="w-full text-center py-3 h-[60px] flex flex-col justify-center">
									<h1 className="text-lg font-bold leading-none">
										{city.name}
									</h1>
									<p className="text-[16px] text-[#5E5E5E] font-medium leading-none">
										{areaCounts[city.name]?.totalCount || 0} venues
									</p>
								</div>
							</div>
						))}
					</div>
				</div>
				<div className="md:hidden block mt-10">
					<ImageCarousel onCityClick={handleRedirect} />
				</div>
			</div>
		</div>
	);
};

export default Spaces;
